import React, { useEffect, useState } from 'react';

import { TextField } from '@mui/material';

const FIELD_CHANGE_DEBOUNCE_MS = 250;

interface Props {
  ariaLabel: string;
  value?: string;
  onChange: (value: string) => void;
}

export default function EditableTextField({ ariaLabel, onChange, value }: Props) {
  const [draftValue, setDraftValue] = useState(value ?? '');

  useEffect(() => {
    setDraftValue(value ?? '');
  }, [value]);

  useEffect(() => {
    if (draftValue === (value ?? '')) {
      return undefined;
    }

    const debounceTimer = window.setTimeout(() => {
      onChange(draftValue);
    }, FIELD_CHANGE_DEBOUNCE_MS);

    return () => window.clearTimeout(debounceTimer);
  }, [draftValue, onChange, value]);

  return (
    <TextField
      fullWidth
      size="small"
      value={draftValue}
      slotProps={{ htmlInput: { 'aria-label': ariaLabel } }}
      sx={{
        minWidth: 120,
        '& .MuiInputBase-input': {
          fontSize: 13,
          py: 0.75,
        },
      }}
      onChange={(event) => setDraftValue(event.target.value)}
    />
  );
}
